import React, { useCallback, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import styles from '../../../styles/layout.module.css';
import { Breadcrumb, Button, Row, Space, Spin, Typography } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ClusterOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDeviceByName } from '../../../features/devicesTypes/devicesTypes.hooks';
import { deleteDevice, fetchDevice } from '../../../features/devicesTypes/devicesTypes.state';
import { DeviceType } from '../../../features/devicesTypes/devicesTypes.types';

const DeviceTypePage: React.FC = () => {
  const { deviceTypeName } = useParams() as { deviceTypeName: string };
  const dispatch = useDispatch();
  const device = useDeviceByName(deviceTypeName) as DeviceType;

  const handleDeleteButtonClick = useCallback(() => {
    dispatch(deleteDevice({ deviceTypeName }));
  }, [deviceTypeName, dispatch]);

  // const handleCompanyUpdate = useCallback(
  //   (data: Partial<CompanyRoom>) => {
  //     dispatch(updateDevice({ deviceTypeName, data }));
  //   },
  //   [deviceTypeName, dispatch]
  // );

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/devices'>
                <Space>
                  <ClusterOutlined />
                  Группы девайсов
                </Space>
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{device.name}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            {device.name}
          </Typography.Title>
          <Space size='small' />
        </div>
        <div className={styles.sidebar}>
          <Space direction='vertical' size='small'>
            <Button type='link' onClick={handleDeleteButtonClick} danger size='small' style={{ padding: 0 }}>
              <DeleteOutlined /> Удалить группу девайсов
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

const DeviceTypePageBlock: React.FC = () => {
  const { deviceTypeName } = useParams() as { deviceTypeName: string };
  const dispatch = useDispatch();
  const device = useDeviceByName(deviceTypeName);

  useEffect(() => {
    dispatch(fetchDevice({ deviceTypeName }));
  }, [deviceTypeName, dispatch]);

  if (!device) {
    return (
      <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
        <Spin size={'large'} />
      </Row>
    );
  }

  return <DeviceTypePage />;
};

export default DeviceTypePageBlock;
